import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'

// The page is a chunk of its own: the canvas, the sections, the portrait and
// this experience's stylesheet have no business in the portal's first paint.
// `anniversary.css` is imported by `Anniversary.tsx` rather than here, so it
// travels with that chunk — imported here it landed in the shared stylesheet
// and shipped ~17 kB of launch-page CSS to every console and portal route.
export const AnniversaryPage = lazy(() => import('./Anniversary'))

// The overview shown after the launch. Its own chunk again: someone who only
// ever opens the anniversary page should not download it.
export const OverviewPage = lazy(() => import('./Overview'))

// Until that chunk's CSS arrives there is no `.a-root` rule, and the default
// page is white. One inline declaration keeps the ground dark across the gap;
// everything else waits for the stylesheet.
const GROUND = { background: 'hsl(216 70% 4%)', colorScheme: 'dark' } as const

/** A dark frame so the chunk's arrival is never preceded by a white flash. */
export function AnniversaryFallback() {
  return <div style={{ ...GROUND, minHeight: '100vh' }} aria-busy="true" />
}

export function AnniversaryLayout() {
  return (
    <div className="a-root" style={GROUND}>
      <Suspense fallback={<AnniversaryFallback />}>
        <Outlet />
      </Suspense>
    </div>
  )
}
